<template>
  <div id="app">
    <div class="container-fluid" v-if="isLogged">
      <Search />
      <Navigation />
      <router-view/>
    </div>
    <div v-else>
      <Login />
    </div>
    <Messenger></Messenger>
  </div>
</template>

<script>
import Search from '@/components/Search.vue'
import Navigation from '@/components/Navigation.vue'
import Login from '@/components/Login.vue'
import Messenger from '@/components/Messenger.vue'

export default {
  components: {
    Search,
    Navigation,
    Login,
    Messenger
  },
  computed: {
    isLogged () {
      return this.$store.state.User != null
    }
  },
  onIdle() {
    this.$router.currentRoute.name !== 'signout' && this.$router.replace({ name: 'signout' }).catch(() => {})
  },
  mounted() {
    
  }
}
</script>

<style>
a {
  cursor: pointer
}
</style>
